export default __webpack_public_path__ + "static/media/tick.7adff12a.svg";